var map = {
	"./oin-pay-bg.svg": "3949",
	"./oin-pay-icon.svg": "dac3",
	"./other_pay_alipay.svg": "82d9",
	"./other_pay_alipay2.svg": "0bb5",
	"./other_pay_cash.svg": "51ec",
	"./other_pay_credit_card.svg": "5938",
	"./other_pay_credit_card2.svg": "29d0",
	"./other_pay_credit_card3.svg": "6204",
	"./other_pay_easywallet.svg": "06ac",
	"./other_pay_easywallet2.svg": "6f8b",
	"./other_pay_googlepay.svg": "6d99",
	"./other_pay_linepay.svg": "d6ae",
	"./other_pay_linepay2.svg": "8354",
	"./other_pay_oinpay.svg": "dd86",
	"./other_pay_pi.svg": "ef6f",
	"./other_pay_pi2.svg": "1173",
	"./other_pay_samsungpay.svg": "8514",
	"./other_pay_wechatpay.svg": "52cc",
	"./other_pay_wechatpay2.svg": "0002",
	"./pay_card1.svg": "0d2d",
	"./pay_card2.svg": "4de40",
	"./pay_fingerprint.svg": "29ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebad";